export default function () {
	return {
		init() {
			this.attachEvents()
		},

		attachEvents() {
			if (this.$refs.readMoreTrigger && this.$refs.readMoreContainer) {
				this.$refs.readMoreTrigger.addEventListener('click', (e) => {
					e.preventDefault()

					this.$refs.readMoreContainer.scrollIntoView({ block: 'start', behavior: 'smooth' })
				})
			}

			this.$root.querySelectorAll('select[name="orderby"]').forEach((el) => {
				el.addEventListener('change', (e) => {
					this.orderBy(e)
				})
			})
		},

		orderBy(e) {
			const form = e.target.closest('form')

			if (form) {
				form.submit()
			}
		},
	}
}
